<template>
  <div class="card">
    <div class="card-header">
      <div class="card-header-title">
        <div class="title is-6 is-marginless">
          Χρέωση βάσει Αξίας Παραγγελίας
        </div>
      </div>
      <div class="card-header-icon">
        <div class="field has-addons is-marginless">
          <div class="control">
            <button
              v-if="isEditing"
              type="button"
              class="button"
              @click="isEditing = !isEditing"
            >
              <span class="icon is-small"><i class="fa fa-eye"/></span
              ><span>Προβολή</span>
            </button>
            <button
              v-else
              type="button"
              class="button"
              @click="isEditing = !isEditing"
            >
              <span class="icon is-small"><i class="fa fa-pencil"/></span
              ><span>Επεξεργασία</span>
            </button>
          </div>
          <div v-if="isEditing" class="control">
            <button type="button" class="button" @click="addCharge">
              <span class="icon is-small"><i class="fa fa-plus"/></span
              ><span>Προσθήκη</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-content">
      <table class="table is-bordered is-striped is-fullwidth">
        <thead>
          <tr>
            <th>Operator</th>
            <th>Αξία Παραγγελίας</th>
            <th>Χρέωση</th>
            <th v-if="isEditing">Ενέργειες</th>
          </tr>
        </thead>
        <tbody v-if="charges.sum.length">
          <charge
            v-for="(charge, index) in charges.sum"
            :charge="charge"
            :is-editing="isEditing"
            :key="index"
            @deleteItem="deleteItem"
            @updateItem="updateItem"
          />
        </tbody>
        <tbody v-else>
          <tr>
            <td class="has-text-centered" colspan="4">Δε βρέθηκαν χρεώσεις</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import shortid from 'shortid';
import Charge from './components/Charge';

export default {
  components: {
    Charge,
  },
  props: {
    charges: Object,
  },
  data() {
    return {
      isEditing: false,
    };
  },
  methods: {
    addCharge() {
      const charges = [
        ...this.charges.sum,
        {
          id: shortid.generate(),
          operator: '>=',
          limit: 0,
          charge: 0,
        },
      ];

      this.$emit('updateSumCharges', charges);
    },
    deleteItem(item) {
      const charges = this.charges.sum.filter(({ id }) => id !== item.id);

      this.$emit('updateSumCharges', charges);
    },
    updateItem(item) {
      const charges = this.charges.sum.map(charge =>
        item.id === charge.id
          ? {
              ...charge,
              ...item,
            }
          : charge,
      );

      this.$emit('updateSumCharges', charges);
    },
  },
};
</script>
